export interface Video {
    id: number;
    title: string;
    description: string;
    thumbnail_url: string | null;
    is_free: boolean;
    price: number;
    price_with_tax: number;
    duration_seconds: number | null;
    status: 'draft' | 'published';
    status_display: string;
    published_at: string | null;
    views_count: number;
    publisher: string;
    organization_id: number | null;
    created_at: string;
    can_play: boolean;
    purchased: boolean;
    can_manage: boolean;
}

export const formatDuration = (seconds: number | null) => {
    if (!seconds) return '';
    const minutes = Math.floor(seconds / 60);
    const rest = seconds % 60;
    return `${minutes}:${String(rest).padStart(2, '0')}`;
};
